import React from "react";

const Pools = ({ tiles }) => {
  const poolData = [
    { name: "Global Pool", icon: "/images/global.png", count: tiles?.globalPoolCount, amount: tiles?.globalTotalBalance ?? 0 },
    { name: "Vision Pool", icon: "/images/vision.png", count: tiles?.visionPoolCount, amount: tiles?.visionTotalBalance ?? 0 },
    { name: "Mission X", icon: "/images/misionx.png", count: null, amount: tiles?.misionxBalance ?? 0 },
    { name: "XION", icon: "/images/vision.png", count: null, amount: tiles?.xionBalance ?? 0 },
  ];

  return (
    <div className="pools-container">
      {poolData.map((pool, index) => (
        <div key={index} className="pool-card">
          <div className="pool-icon-container">
            <img src={pool.icon} alt={`${pool.name} icon`} className="pool-icon" />
          </div>
          <div className="pool-details">
            <h4 className="pool-title">{pool.name}</h4>
            {pool.count != null && (
              <div className="count-container">
                <span className="count-label">Participants</span>
                <p className="pool-value">{pool.count.toLocaleString()}</p>
              </div>
            )}
            <p className="pool-label">
              Balance : <span className="pool-amount">${parseFloat(pool.amount).toFixed(4)}</span>
            </p>
          </div>
        </div>
      ))}

      <style jsx>{`
        .pools-container {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
          justify-content: center;
        }

        .pool-card {
          display: flex;
          align-items: center;
          background-color: #fff;
          border-radius: 5px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          flex: 1;
          min-width: 240px;
          min-height: 120px;
          height: auto;
        }
        
        .pool-icon-container {
          background-color: #f5f5f5;
          height: 100%;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pool-icon {
          filter: grayscale(90%);
          width: 2.5rem;
          height: 2.5rem;
          object-fit: contain;
        }
        

        .pool-details {
          padding: 0.75rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .pool-title {
          font-size: 1rem;
          font-weight: bold;
          color: #1f2937;
          margin: 0 0 0.25rem 0;
        }

        .count-container {
          display: flex;
          flex-direction: column;
          margin-bottom: 0.25rem;
        }

        .count-label {
          font-size: 0.8rem;
          color: #555;
        }

        .pool-value {
          font-size: 1.3rem;
          color: black;
          font-weight: 700;
          margin: 0;
          line-height: 1.2;
        }

        .pool-label {
          font-size: 0.85rem;
          color: #555;
          margin: 0;
        }

        .pool-amount {
          font-weight: 600;
          color: black;
        }

        @media (max-width: 768px) {
          .pools-container {
            flex-direction: column;
            align-items: center;
          }

          .pool-card {
            width: 100%;
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default Pools;